var app = {
    newVue:null,
    initVue:function(){
        this.newVue=new Vue({
            el: "#pageBox",
            data:function(){
                return{
                    videos:{
                        list:[],
                        recommend:{}
                    },
                    wave:null,
                    bannerSwiper:null,
                    posterSwiper:null,
                    posterSwiperIndex:-1,
                    user_integral:0,
                    user_integral_text: '',
                    moreVideos:{
                        isShow:false,
                        btnTxt:'查看更多'
                    },
                    // 大事件
                    bigEvents:[
                        {
                            date:'2019年10月',
                            text:'戴尔科技集团与中国皮划艇协会和中国赛艇协会签署赞助协议，<br/>戴尔科技集团成为“中国国家皮划艇队官方赞助商”<br/>及“中国国家赛艇队官方赞助商”，并助力龙舟入奥。'
                        },{
                            date:'2019年11月',
                            text:'<a href="https://mp.weixin.qq.com/s/6bJHAQGhWfxVD2RNptlirQ" target="_blank">戴尔科技集团进一步与中国皮划艇协会和中国赛艇协会<br/>签署水上实验室的技术战略合作，<br/>用科技赋能中国国家赛艇队及皮划艇队。</a>'
                        },{
                            date:'2020年6月',
                            text:'<a href="https://caijing.chinadaily.com.cn/a/202006/24/WS5ef32103a310a859d09d427c.html" target="_blank">让民族的成为世界的——赛龙舟，戴尔“艇”你所爱。</a><br/>' +
                                '<a href="http://business.china.com.cn/2020-06/09/content_41177830.html" target="_blank">戴尔力挺国家队！每一位运动员的热爱都值得被尊敬。</a>'
                        },{
                            date:'2020年9月',
                            text:'<a href="http://biz.ifeng.com//c//80BcUi6QvBk" target="_blank">在中国·为中国——二十二年中国梦，戴尔与你同行。</a>'
                        },{
                            date:'2020年10月',
                            text:'<a href="https://caijing.chinadaily.com.cn/a/202010/12/WS5f8403a8a3101e7ce9728c6c.htm" target="_blank">戴尔科技集团成功研发“数字体能监测系统”，首次亮相进博会。<br/>' +
                                '该套解决方案利用人工智能技术，凭借高性能计算<br/>' +
                                '以及边缘/核心计算解决方案，利用视频实时捕捉<br/>' +
                                '国家队运动员的训练动作，并做出实时分析和判断，<br/>' +
                                '纠正运动训练中动作角度、力度，以及稳定性的偏差，<br/>' +
                                '帮助赛艇运动员提高训练竞技水平。</a>'
                        },{
                            date:'2020年11月',
                            text:'<a href="https://www.163.com/news/article/FS74DB3G00019OH3.html" target="_blank">以科技赋能体育,戴尔科技见证荣耀每一刻。</a><br/>' +
                                '<a href="http://software.it168.com/a2020/1107/6384/000006384900.shtml" target="_blank">科技力量与竞技梦想的交融——戴尔科技，竞舟中国梦！</a>'
                        },
                        {
                            date:'2021年3-4月',
                            text:'戴尔科技集团的科研人员进驻国家队，与国家队的教练、<br/>' +
                                '科研人员、运动员实地交流，对解决方案进行不断的完善及改进,<br/>' +
                                '考察了测功仪应用在皮艇、划艇项目上的可行性，<br/>' +
                                '探索了室外无人机训练的可行性。'
                        },{
                            date:'2021年4月',
                            text:'<a href="http://caijing.chinadaily.com.cn/a/202104/15/WS6077ed5ea3101e7ce97495af.html" target="_blank">倒计时100天，中国国家赛艇队和皮划艇队蓄势待发艇进东京。</a>'
                        },{
                            date:'2021年6月',
                            text:'<a href="http://sm.guoqing.china.com.cn/2021-06/23/content_41600991.html" target="_blank"> “黑科技”加持，戴尔助力赛艇皮划艇运动员竞舟中国梦。</a>'
                        },{
                            date:'2021年7月',
                            text:'<a href="http://www.xinhuanet.com/tech/2021-07/07/c_1127631254.htm" target="_blank">戴尔科技集团大数据与人工智能联合实验室揭牌仪式成功举行。</a><br>' +
                                '<a href="javascript:void(0);"  onclick="msg.imgPreviewDialog(\'http://smarket.dellemc-solution.com/f/dellemc/sFile/tenantId460/2021-07-22/image/1626953375197971.png\', \'东京奥运会赛艇/皮划艇比赛赛程时间一览表\')">东京奥运会赛艇/皮划艇比赛赛程时间一览表。</a>'
                        }
                    ],
                    // 采访 固定四个视频
                    interviewVideos:[
                        {
                            title:'戴尔×中国赛艇皮划艇队',
                            subtitle: '宣传片',
                            coverImageUrl:'https://dellvideo.smarket.net.cn/9747cafc310c4fc49224741a2c755c01/covers/d4903ec5df194a639ef97559c0433163-00004.jpg',
                            url:'https://dellvideo.smarket.net.cn/9747cafc310c4fc49224741a2c755c01/93deb7ab8dfc4950931c2ef652e8bd40-356ec4004291e079e10b4bd3a33ff09e-ld.mp4',
                        },{
                            title:'不被看见的伟大',
                            subtitle: '中国国家赛艇/皮划艇队',
                            coverImageUrl:'/static/pc/img/campaign/olympic-canoeing/video-cover05.jpg',
                            url:'https://dellvideo.smarket.net.cn/cbe80779d7994c749b509a5f0c6270de/96f76dc6adb8494f8c32a49577908caf-df0f291d2d17e32cbed9eb7890b0e3f4-ld.mp4',
                        },{
                            title:'一起呈现荣耀背后的故事',
                            subtitle: '李三平&资薇',
                            coverImageUrl:'https://dellvideo.smarket.net.cn/f00d58080cb440c187c80d63768bbc0d/covers/12ce565c3168404daea4b7eabde44ee9-00002.jpg',
                            url:'https://dellvideo.smarket.net.cn/f00d58080cb440c187c80d63768bbc0d/0122f6ac43364343bfe9718e05a3c842-10f350406ee46b1f975a46e763a9ed6f-ld.mp4',
                        },{
                            title:'一起呈现荣耀背后的故事',
                            subtitle: '徐诗晓&孙梦雅',
                            coverImageUrl:'https://dellvideo.smarket.net.cn/e1c02071c2ed4496bd6da60df2e3eba4/covers/18fc9a19544b4e24b745fcb783ea6298-00004.jpg',
                            url:'https://dellvideo.smarket.net.cn/e1c02071c2ed4496bd6da60df2e3eba4/62b96b3460ba469c994acb4aec735930-61cba536b2db08ca5f2d8260ce810250-ld.mp4',
                        },{
                            title:'一起呈现荣耀背后的故事',
                            subtitle: '张亮&刘治宇',
                            coverImageUrl:'https://dellvideo.smarket.net.cn/f19aaaa6ec054294a812008b7647d6ca/covers/2710f0103f474a2fbd1666994332498e-00005.jpg',
                            url:'https://dellvideo.smarket.net.cn/f19aaaa6ec054294a812008b7647d6ca/47f2744d559948f08ddba8e2eb438d70-96dc496bd1ffd89924caf878e807acc7-ld.mp4',
                        },{
                            title:'一起呈现荣耀背后的故事',
                            subtitle: '赛艇女子四人双桨',
                            coverImageUrl:'/static/pc/img/campaign/olympic-canoeing/video-cover06.jpg',
                            url:'https://dellvideo.smarket.net.cn/3c35415017a2423b91d46f381800a207/40adb2fa78e442ae9de9a8a6de497c13-6e09ec54ced3395e02ea6ba1ee5dfec8-ld.mp4',
                        }
                    ],
                    // 海报
                    posterData:{
                        active:0,
                        data:[
                            {
                                name:'徐诗晓孙梦雅',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic1.png'
                            },{
                                name:'张亮',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic2.png'
                            },{
                                name:'张亮刘治宇',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic3.png'
                            },{
                                name:'龙舟',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic4.png'
                            },{
                                name:'皮划艇',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic5.png'
                            },
                            {
                                name:'赛艇',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic6.png'
                            },{
                                name:'实验室',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic7.png'
                            },{
                                name:'医生',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic8.png'
                            },{
                                name:'教师',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic9.png'
                            },{
                                name:'工程师',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic10.png'
                            },
                            {
                                name:'工程师',
                                text:'',
                                url:'/static/pc/img/campaign/olympic-canoeing/poster/pic11.png'
                            }
                        ]
                    },
                    surplusDays: [],
                    isShowReturnBtn:false,
                    boatUrl: null
                }
            },
            created: function () {
                this.gitVideos();
                this.getDate();
                this.setReturnUrl();
            },
            mounted: function () {
                var _this=this;
                _this.getenergypool();
                _this.$nextTick(function(){
                    // 创建banner
                    // _this.bannerSwiper = _this.newBannerSwiper();

                    _this.posterSwiper = _this.newposterSwiper();
                })

            },
            methods: {
                gitVideos:function(){
                    var _this=this;
                    $.ajax({
                        url:'/api/campaign/getvideos',
                        method:"GET",
                        success:function(data){
                            _this.videos=data.data;
                            console.log(data)
                        },
                        error:function(error){
                            console.log(error)
                        }
                    })
                },
                getenergypool:function(){
                    var _this=this;
                    $.ajax({
                        url:'/api/campaign/getenergypool',
                        method:"GET",
                        success:function(data){
                            console.log(data)
                            _this.wave=_this.newWave(data.data.max);

                            _this.wave.render();
                            _this.user_integral=data.data.heat;
                        },
                        error:function(error){
                            console.log(error)
                        }
                    })
                },
                // 查看更多视频
                moreVideosBtnClick:function(){
                    this.moreVideos.isShow=!this.moreVideos.isShow;
                },
                // 播放视频
                integralPlayVideo:function(url,title,id,e){
                    var _this=this;

                    gio('track', 'olympiccanoeing_videoclick', {
                        'olympiccanoeing_title': title
                    });

                    msg.videoDialog(url, title, id);
                    $.ajax({
                        url:'/api/campaign/addenergypool',
                        method:"GET",
                        data:{
                            vid:id
                        },
                        success:function(data){
                            _this.user_integral+=1;
                        },
                        error:function(error){
                            console.log(error)
                        }
                    })

                    var browseNum=parseInt($(e.currentTarget).find('.browseNum').html())+1;
                    $(e.currentTarget).find('.browseNum').html(browseNum);
                },
                // 不加积分的视频播放
                playVideo:function(url,title){
                    var _this = this;
                    gio('track', 'olympiccanoeing_videoclick', {
                        'olympiccanoeing_title': title
                    });
                    msg.videoDialog(url, title, '', '', '', '', function () {
                        common.setCookie('watchCompleteVideo', true);
                        _this.showLotteryDialog();
                    });
                },
                newWave:function(maxData,data){
                    var _this=this;
                    // var size=(window.innerWidth/750) * 260;
                    return new Wave({
                        canvasId:'c',
                        inputId:'inp',
                        width:210,
                        height:210,
                        maxData:maxData,
                        data:25000,
                        speedWidth:3,
                        waves:[
                            {
                                color:'#ff686c',
                                opacity:0.4,
                                xoffset:0
                            },{
                                color:'#ff5450',
                                opacity:0.8,
                                xoffset:80
                            }
                        ]
                    })
                },
                newBannerSwiper:function(){
                    return new Swiper('.bannerSwiper', {
                        autoplay: true,//可选选项，自动滑动
                        pagination: {
                            el: '.bannerSwiper .swiper-pagination',
                        },
                    })
                },
                newposterSwiper:function(){
                    var _this=this;
                    return new Swiper('#posterSwiper', {
                        slidesPerView: 'auto',
                        spaceBetween: -15,
                        centeredSlides : true,
                        navigation: {
                            nextEl: '.next-btn',
                            prevEl: '.prev-btn',
                        },
                        loop: true,
                        loopedSlides: 5,
                        freeMode: true,
                        observer:true,
                        observeParents:true,
                        on:{
                            init: function(swiper){
                                this.emit('transitionEnd');
                            },
                            transitionEnd: function(swiper){
                                if(_this.posterSwiperIndex!=this.realIndex){
                                    var _index=this.realIndex+1+'';
                                    gio('track', 'olympiccanoeing_tabpicclick', {
                                        'olympiccanoeing_tabpicnumber': _index
                                    });
                                    _this.posterSwiperIndex=this.realIndex;
                                }
                            }
                        }
                    })
                },
                getDate:function(){
                    var _this=this;
                    var endTime=new Date('2021/7/24 00:00:00');
                    // var endTime=new Date('2021/3/12 23:59:59');
                    $.ajax({
                        url:window.solution_host + '/api/getSysTime',
                        method:"GET",
                        success:function(data){
                            var day = _this.mschange(endTime - new Date(data.sysTime*1000)).day;
                            day = day < 10 ? ('0' + day) : day;
                            _this.surplusDays = day.toString().split('');
                            // console.log('获取时间',_this.mschange(endTime - new Date(data.sysTime*1000)))
                        },
                        error:function(error){
                            console.log(error)
                        }
                    })
                },
                mschange:function(num) {
                    var num1 = parseInt(num / 1000);
                    var miao = parseInt(num1 % 60);//秒
                    var minute = parseInt((num1 / 60) % 60);//分
                    var hour = parseInt((num1 / 60 / 60) % 24);//小时
                    var day = parseInt(num1 / 60 / 60 / 24);//天
                    return {
                        'miao': miao,
                        'minute': minute,
                        'hour': hour,
                        'day': day
                    }
                },
                setReturnUrl: function (){
                    var boatType = common.getUrlPara('boat');
                    var userNum = common.getUrlPara('usernum');
                    if(boatType){
                        switch (boatType) {
                            case '1':
                                this.boatUrl = common.urlAddPara('https://wechat.iwait4you.cn/Dell/canoeing202105/index/boat/', 'usernum', userNum);
                                this.isShowReturnBtn = true;
                                break;
                            case '2':
                                this.boatUrl = common.urlAddPara('https://wechat.iwait4you.cn/Dell/canoeing202105/index/boatnew/', 'usernum', userNum);
                                this.isShowReturnBtn = true;
                                break;
                            default:
                                this.boatUrl = null;
                                this.isShowReturnBtn = false;
                                break;
                        }
                    }
                },
                goToReturn: function () {
                    window.location.href = this.boatUrl;
                },

                showLotteryDialog: function () {
                    // 判断是否参与
                    postJson(window.cateData.api.getLuckyWinInfo,{
                        tenantId: window.cateData.tenantId,
                        luckyDrawId: 3891, //
                        sess: isLogin().session,
                        globalUserId: $.cookie('globalUserId')
                    },function (res) {
                        $('.lottery-dialog').show();
                        $('.lottery-dialog .mask').addClass('dialog-mask-ani-fade-in');
                        $('.lottery-dialog .dialog-content').addClass('dialog-ani-from-top');
                        if (res.body.content.isParticipate == 1){
                            // 已参与
                            $('.j-is-lottery').show();
                        }else {
                            // 未参与
                            $('.j-to-lottery').show();
                        }
                    })
                },

                closeLotteryDialog: function () {
                    $('.lottery-dialog .mask').removeClass('dialog-mask-ani-fade-in');
                    $('.lottery-dialog .dialog-content').removeClass('dialog-ani-from-top');
                    $('.lottery-dialog .mask').addClass('dialog-mask-ani-fade-out');
                    $('.lottery-dialog .dialog-content').addClass('dialog-ani-to-top');
                    setTimeout(function () {
                        $('.lottery-dialog').hide();
                        $('.lottery-dialog .dialog-content').removeClass('dialog-ani-to-top');

                    },230);
                    setScroll.removeUnScroll();
                },

                toLottery: function () {
                    /*if(!isLogin()){

                        msg.dialog('您还没有登录，登录后即可参与抽奖', function(){
                            msg.toast('正在跳转登录~');
                            common.gotoLogin();
                        }, function () {

                        }, '', 1, '', '立即登录', '');

                        return;
                    }*/
                    if(!isLogin()){
                        msg.toast('正在跳转登录~');
                        common.gotoLogin('','','',1);
                        return;
                    }
                    event.stopPropagation();
                    window.location.href = '/campaign/iframeview'
                        + '?url=' + encodeURIComponent('https://smarket.dellemc-solution.com/u/hBtqZ2')
                        + '&redirectUrl=' + window.location.href + '&needLogin=0&luckyDrawId=3891';
                },

                showLottery: function () {
                    if(!isLogin()){
                        msg.toast('正在跳转登录~');
                        common.gotoLogin('','','',1);
                        return;
                    }

                    if(!common.getCookie('watchCompleteVideo')){
                        msg.toast('观看“企业宣传视频”才可以参加抽奖哦~');
                        pos.init('video-container');
                        return;
                    }

                    this.showLotteryDialog();

                }
            },
            watch: {
                'moreVideos.isShow': {
                    handler: function (val, oldval) {
                        if(val){
                            this.moreVideos.btnTxt='收起更多'
                        }else{
                            this.moreVideos.btnTxt='查看更多'
                        }
                    },
                },
                'user_integral': {
                    handler: function (val, oldval) {
                        this.wave.setData(val);
                        function format (num) {
                            var reg=/\d{1,3}(?=(\d{3})+$)/g;
                            return (num + '').replace(reg, '$&,');
                        }
                        this.user_integral_text = format(val);
                        console.log(this.user_integral_text);
                        console.log(val)
                    },
                },
            }
        })
    },
    init:function(){
        this.initVue();
    }
}
function getUserInfoAfter() {
    app.init();
}


